import { render, staticRenderFns } from "./getwaybill.vue?vue&type=template&id=0f9929a1&scoped=true&"
import script from "./getwaybill.vue?vue&type=script&lang=js&"
export * from "./getwaybill.vue?vue&type=script&lang=js&"
import style0 from "./getwaybill.vue?vue&type=style&index=0&id=0f9929a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9929a1",
  null
  
)

export default component.exports